module.exports = __webpack_public_path__ + "static/img/image-bg.349c2fb7.png";